import { computed } from '@angular/core';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faStreetView } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoService } from '@jsverse/transloco';
import { Map } from 'maplibre-gl';

import { AbstractMapControl } from '@connect-services/client/components/map/abstract-map-control';
import { ViewParam } from '@connect-services/client/components/map/map.component';
import { ImmersiveViewService } from '@connect-services/client/services/immersive-view/immersive-view.service';

export class ImmersiveViewControl extends AbstractMapControl {
    private readonly viewParam = computed<ViewParam>(() => {
        return this.immersiveViewService.isImmersiveViewActive()
            ? { icon: faStreetView, labelTranslation: 'immersiveView.close' }
            : { icon: faStreetView, labelTranslation: 'immersiveView.open' };
    });

    public constructor(
        map: Map,
        private readonly immersiveViewService: ImmersiveViewService,
        private readonly translocoService: TranslocoService,
    ) {
        super();
        this.map = map;
    }

    public updateVisibility(): void {
        this.refreshButton();
    }

    protected initButton(): void {
        this.setupButton('immersive-view-control', () => this.handleControl(), ['immersive-view-control']);
        this.refreshButton();
    }

    private handleControl(): void {
        if (!this.map || !this.immersiveViewService.canUseImmersiveView()) {
            return;
        }

        this.immersiveViewService.toggleImmersiveView();
        this.refreshButton();
    }

    private refreshButton(): void {
        const canImmersiveView = this.immersiveViewService.canUseImmersiveView();
        const { canNavigate } = this.immersiveViewService.immersiveViewPermissions();

        let tooltipKey: string = this.viewParam().labelTranslation;

        if (!canNavigate) {
            tooltipKey = 'immersiveView.disableForThisPage';
        } else if (!canImmersiveView) {
            tooltipKey = 'immersiveView.accessDenied';
        }

        this.setButtonIcon(icon(this.viewParam().icon).html[0]);

        this.setButtonState({
            isActive: this.immersiveViewService.isImmersiveViewActive(),
            isDisabled: !canImmersiveView,
        });

        this.setButtonTitle(this.translocoService.translate(tooltipKey));
    }
}
